import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class App extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  bundleIdentifier: string;
}
